// extracted by mini-css-extract-plugin
export default {"Content":"sample-calc-proportion-detail_Content__jiSZp","Toolbar":"sample-calc-proportion-detail_Toolbar__qHoEA"};